import React from 'react'
import Layout from '../../components/layout/Layout'
import WarehouseTable from '../../elements/tables/warehouse/WarehouseTable'

export default function Warehouse() {
  return (
    <div>
      <Layout>
        <WarehouseTable />
      </Layout>
    </div>
  )
}
